/* eslint-disable jsx-a11y/control-has-associated-label */
import { Trans } from 'react-i18next';
import { ServiceData, ServiceState } from '@root/store/services';
import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import styles from './Item.module.scss';
import Icon from '@root/components/Icon';

type ItemProgressProps = {
    service: ServiceData;
};

type ItemProccessTextProps = {
    service: ServiceData;
};

const ItemProccessText: PageComponent<ItemProccessTextProps> = ({
    service,
}) => {
    if (service.state === ServiceState.CREATING) {
        if (service.type === 'ds') {
            return (
                <Trans
                    i18nKey="stateProccess.creating_ds"
                    ns="uiServicesMain"
                >
                    Serveris kūriamas
                </Trans>
            );
        }
        if (service.type === 'vds') {
            return (
                <Trans
                    i18nKey="stateProccess.creating_vds"
                    ns="uiServicesMain"
                >
                    Serveris kūriamas
                </Trans>
            );
        }
        return (
            <Trans i18nKey="stateProccess.creating" ns="uiServicesMain">
                Serveris kūriamas
            </Trans>
        );
    }
    return (
        <Trans i18nKey="stateProccess.locked" ns="uiServicesMain">
            Serveris vykdo veiksma
        </Trans>
    );
};

const ItemProccess: PageComponent<ItemProgressProps> = ({ service }) => {
    return (
        <div className={styles.service_item}>
            <div className={styles.progress_container}>
                <Icon
                    src={'/static/img/icons/spinner.svg'}
                    className={styles.placeholder_icon}
                />
                <h1>
                    <ItemProccessText service={service} />
                </h1>
                <div
                    className={classNames(
                        styles.progress,
                        styles.indeterminate,
                    )}
                >
                    <div
                        className={classNames(styles.progress_inner)}
                        role="progressbar"
                        style={
                            {
                                /*
                            width: `${percentage}%`
                            */
                            }
                        }
                    />
                </div>
                {/*
                <span>{percentage}%</span>
                */}
            </div>
        </div>
    );
};

export default ItemProccess;
